import apiClient from "../web/ApiClient";

/**
 * This is a utility interface to represent a code repo
 */
export interface CodeRepositoryEntry {
  codeRepositoryId: number;
  username: string;
}

/**
 * This is an interface to represent the fields we need to populate a code repo
 */
export interface CodeRepository {
  repositoryId: number;
  repositoryName: string;
}

/**
 * We store this list so we don't have to recompute it all the time
 */
const codeRepositoriesList: CodeRepository[] = [];

/**
 * This function is used to lazily load the code repositories list
 */
export async function loadCodeRepositories(): Promise<CodeRepository[]> {
  // Return list if already computed
  if (codeRepositoriesList.length > 0) {
    return codeRepositoriesList;
  }

  await apiClient.get('/ams/ui-api/v1/code-repositories', {})
  .then((response) => {
    response.data.data.forEach((repo: CodeRepository) => {
      codeRepositoriesList.push(repo);
    })
  }).catch((error) => {
    console.warn(`Error when loading the code repositories: ${error.message}`);
    return [];
  });

  return codeRepositoriesList;
}